<p>payable works!</p>
<main id="main" class="main">
  <section class="section dashboard">
    <!-- Header -->
    <div class="row">
      <div class="col-md-12">
        <h6 class="admintitle">
          Payables&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
      </div>
    </div>
<!-- Group Type Buttons -->


<!-- Group Members List -->


<!-- Toggle Buttons -->
<!-- Toggle Buttons -->
<div class="row justify-content-center g-0 mb-3">
  <div class="col-md-2 p-0" (click)="selectType('partner')" style="cursor: pointer;">
    <div class="card text-center">
      <h6 [ngClass]="['block', selectedType === 'partner' ? 'active' : '']" class="mb-0">Partners</h6>
    </div>
  </div>

  <div class="col-md-2 p-0" (click)="selectType('advisor')" style="cursor: pointer;">
    <div class="card text-center">
      <h6 [ngClass]="['block', selectedType === 'advisor' ? 'active' : '']" class="mb-0">Advisors</h6>
    </div>
  </div>
</div>

<!-- Show table only after selection -->
<!-- One table rendered dynamically -->
<div class="table-responsive mt-2" *ngIf="selectedType" style="margin-bottom: 48px;">
  <table
    datatable
    [dtOptions]="dtOptions"
    [dtTrigger]="dtTrigger"
    class="table text-nowrap"
  >
    <thead>
      <tr>
        <!-- <th>S.No</th> -->
        <th>ID</th>
        <th>Broker Id</th>
        <th>Partner Id</th>
        <th>{{ selectedType === 'advisor' ? 'Advisor' : 'Partner' }} Name</th>
        <th>Date</th>
        <th class="text-end">Amount</th>
        <th>Status</th>
        <th>History</th>
        <th>Record Type</th>
        <th>Created </th>
        <th>Modified</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of selectedType === 'advisor' ? advisorData : partnerData">
        <!-- <td>{{ row.sno }}</td> -->
        <td>{{ row.id }}</td>
        <td>{{row.brokerId}}</td>
        <td>{{row.partnerId}}</td>
        <td>{{ row.name }}</td>
        <td>{{row.date | date: 'MM/dd/yyyy'}}</td>
        <td class="text-end">{{ row.amount | currency: 'USD':'symbol':'1.2-2' }}</td>
        <td>{{row.status}}</td>
        <!-- <td>{{row.history}}</td> -->
         <td>
  {{ row.history?.note }}<br />
  <small class="text-muted">{{ row.history?.timestamp | date:'medium' }}</small>
</td>
        <td>{{row.recordType}}</td>
        <td>{{row.created | date: 'MM/dd/yyyy'}}</td>
        <td>{{row.modified | date: 'MM/dd/yyyy'}}</td>
        <td>
          <button class="btn btn-sm btn-outline-primary" (click)="viewExcel(row.excelFile)">View</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>



  </section>
</main>
